import { Toast } from "antd-mobile";
import axios from "axios";

export const upload = async (options) => {
  const { file, onSuccess, token, mobile } = options;
  try {
    const result: any = await axios({
      baseURL: "",
      url: `/api/xp-dragon-koi-boot/h5/v1/customer/file/getUploadUrl`,
      method: "post",
      data: {
        fileName: (file as File)?.name,
        fileSize: (file as File)?.size || 0,
        token,
        mobile,
      },
    });

    const reader = new FileReader();
    reader.readAsArrayBuffer(file);
    const fileData: any = await new Promise((resolve) => {
      reader.onloadend = function () {
        resolve(reader.result);
      };
    });
    try {
      const xhr = new XMLHttpRequest();
      await new Promise((resolve, reject) => {
        xhr.onloadend = () => {
          if (xhr.readyState === 4 && xhr.status === 200) {
            resolve(true);
          } else {
            reject(xhr.status);
          }
        };
        xhr.onerror = reject;
        xhr.open("PUT", result?.data?.data?.uploadUrl, true);
        xhr.setRequestHeader("Content-Type", "application/octet-stream");
        xhr.send(fileData);
      });
    } catch (error) {
      Toast.show("上传失败");
      throw new Error("上传失败");
    }
    onSuccess!({ ...result.data });
  } catch (e: any) {
    const msg = e.response?.data?.msg || "网络异常";
    Toast.show(msg);
    throw new Error("上传失败");
  }
};
